import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import Toad from '../assets/images/toad.png';
import Beetle from '../assets/images/beetle.png';
import DustMite from '../assets/images/dustmite.png';
import PollenGrain from '../assets/images/pollen.png';
import BloodCell from '../assets/images/blood.png';
import CircleWithBorder from "./circle-with-border";
import Squiggle from "./squiggle";

class AnimationNew extends Component {

    constructor( props ) {
        super( props );

        this.state = {
            animationPlaying: false
        };

        this.animationCountdown = null;
    }

    componentDidMount() {
        // Start animation after countdown.
        this.animationCountdown = setTimeout( () => {
            this.setState({
                animationPlaying: true
            });
        }, 4000 );
    }

    componentWillUnmount() {
        clearTimeout( this.animationCountdown );
    }

    render() {
        const { skip } = this.props;
        const { animationPlaying } = this.state;
        const classes = classnames(
            'animation-circles',
            { 'play-animation' : animationPlaying }
        );

        let styles = {
            opacity: 1
        };

        if( skip ) {
            styles = {
                opacity: 0
            }
        }

        if( isMobile ) {
            return null;
        }


        return (
            <div className="new-animation-container" style={ styles }>

                <div className={ classes }>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>

                    </div>
                    <div className="circle">

                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle">
                        <img src={ Toad } className="image toad" />
                        <div className="animation-new-title toad">
                            <CircleWithBorder>
                                <h2><span>Common</span> <span>Toad</span></h2>
                            </CircleWithBorder>
                        </div>
                        <div className="scale-label toad">
                            <span><strong>Scale:</strong> 0.1 metres</span>
                            <Squiggle className="scale-squiggle"/>
                        </div>
                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle" />

                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle">
                        <div className="animation-new-title beetle">
                            <CircleWithBorder>
                                <h2><span>Darkling</span> <span>Beetle</span></h2>
                            </CircleWithBorder>
                        </div>
                    </div>
                    <div className="circle">
                        <div className="scale-label beetle">
                            <span><strong>Scale:</strong> 0.01 metres</span>
                            <Squiggle className="scale-squiggle"/>
                            <div className="scale-label-block" />
                        </div>
                    </div>
                    <div className="circle">
                        <img src={ Beetle } className="image beetle" />
                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle" />

                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle">
                        <div className="animation-new-title dustmite">
                            <CircleWithBorder>
                                <h2><span>Dust</span> <span>Mite</span></h2>
                            </CircleWithBorder>
                        </div>
                    </div>
                    <div className="circle">
                        <div className="scale-label dustmite">
                            <span><strong>Scale:</strong> 0.0001 metres</span>
                            <Squiggle className="scale-squiggle"/>
                            <div className="scale-label-block" />
                        </div>
                    </div>
                    <div className="circle">
                        <img src={ DustMite } className="image dustmite" />
                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle" />

                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle">
                        <div className="animation-new-title pollen">
                            <CircleWithBorder>
                                <h2><span>Pollen</span> <span>Grain</span></h2>
                            </CircleWithBorder>
                        </div>
                    </div>
                    <div className="circle">
                        <div className="scale-label pollen">
                            <span><strong>Scale:</strong> 0.00005 metres</span>
                            <Squiggle className="scale-squiggle"/>
                            <div className="scale-label-block" />
                        </div>
                    </div>
                    <div className="circle">
                        <img src={ PollenGrain } className="image pollen" />
                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle" />

                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle">
                        <div className="animation-new-title blood">
                            <CircleWithBorder>
                                <h2><span>Red</span> <span>Blood</span> <span>Cell</span></h2>
                            </CircleWithBorder>
                        </div>
                    </div>
                    <div className="circle">
                        <div className="scale-label blood">
                            <span><strong>Scale:</strong> 0.00001 metres</span>
                            <Squiggle className="scale-squiggle"/>
                            <div className="scale-label-block" />
                        </div>
                    </div>
                    <div className="circle">
                        <img src={ BloodCell } className="image blood" />
                    </div>
                    <div className="circle">
                        <div className="rotator">
                            <div className="spot" />
                            <div className="spot" />
                        </div>
                    </div>
                    <div className="circle" />
                </div>

            </div>
        );
    }

}

AnimationNew.defaultProps = {
    skip: false
};

AnimationNew.propTypes = {
  skip: PropTypes.bool
};

export default AnimationNew;


// WEBPACK FOOTER //
// ./src/components/animation-new.js